/**
 * Copyright 2020, ChoTot Ltd. Licensed under the Apache License, Version 2.0.
 *
 * Developer's Notes:
 * This is an example of component whose styles are highly dynamic and
 * dependent on many props.
 *
 * The reason we wrap the StyledComponent with another FunctionComponent is that
 * Storybook will pick up the JSDoc and prop type desription correctly.
 */
import * as React from 'react';
import { StyledComponent } from './ShapeIcon.styles';
const ShapeIcon = ({ as = 'span', size = 'sm', radius = 'circle', bg = 'none', color = 'text', children, ...attrs }) => (<StyledComponent as={as} size={size} radius={radius} bg={bg} color={color} data-clad="Shape Icon" {...attrs}>
    {children}
  </StyledComponent>);
export default ShapeIcon;
